import { addStyles } from 'ethcss'
import { mediaCSS } from 'blocks.app/config'
import grid from 'blocks.simple/grid/grid.jcss'
import item from 'blocks.simple/item/item.jcss'
import { color } from 'theme/tokens/color'
import { colors, IStyles } from '../../../theme'

const deviceSettingsTimerStyles: IStyles = {
    additional: {
        display: 'flex',
        height: 160,
        marginTop: 14,

        [mediaCSS.laptop]: {
            height: 'auto',

            [mediaCSS.tab]: {
                justifyContent: 'space-between',

                [mediaCSS.tabMini]: {
                    ...grid.col,
                },
            },
        },
    },
    timersWrapper: {
        marginBottom: 14,
    },
    timerContainer: {
        display: 'flex',
        width: '100%',

        [mediaCSS.tab]: {
            justifyContent: 'space-between',

            [mediaCSS.tabMini]: {
                ...grid.col,
            },
        },
    },
    timer: {
        ...grid.col,
        width: 550,
        ...grid.flexStart,
        ...grid.p_mini,
        background: colors.water,
        marginRight: 14,
        marginBottom: 14,

        [mediaCSS.laptop]: {
            width: '48%',

            [mediaCSS.tab]: {
                marginRight: 0,

                [mediaCSS.tabMini]: {
                    ...grid.col,
                    ...grid.w100,
                },
            },
        },
        height: '100%',
        borderRadius: 8,
    },
    singleTimer: {
        ...grid.col,
        ...grid.p_mini,
        width: 550,
        marginRight: 14,
        marginBottom: 14,
        background: colors.water,

        [mediaCSS.laptop]: {
            width: '48%',

            [mediaCSS.tab]: {
                marginRight: 0,

                [mediaCSS.tabMini]: {
                    ...grid.col,
                    ...grid.w100,
                },
            },
        },

        borderRadius: 8,
    },
    timers: {
        ...grid.row,
        ...grid.fullWidth,
        ...grid.p_md,
        ...grid.pt_none,
        ...item.rounded_full_mini,
    },
    label: {
        fontSize: 14,
    },
    sleepMode: {
        marginTop: 21,
    },
    checkbox: {
        marginTop: 29,
    },
    sleepModeDesc: {
        marginTop: 10,
    },
    tabs: {
        display: 'flex',
        gap: 14,
        marginBottom: 16,

        [mediaCSS.tab]: {
            display: 'block',
        },
    },
    tabActive: {
        background: colors.blueAccent,
        color: `${colors.white} !important`,
        border: 'none',
    },
    tab: {
        [mediaCSS.tab]: {
            marginRight: 10,
            marginBottom: 10,
        },
    },
    onIcon: {
        width: 12,
        height: 12,
        background: colors.online,
        borderRadius: '50%',
    },
    offIcon: {
        width: 12,
        height: 12,
        background: colors.errorSaturated,
        borderRadius: '50%',
    },
    hint: {
        color: color.fontDarkMedium,
    },
}

addStyles(deviceSettingsTimerStyles)
export default deviceSettingsTimerStyles
